import ActorModal from './ActorModal'
import CampaignModal from './CampaignModal'
import MalwareModal from './MalwareModal'
import ServiceDetailsModal from './ServiceDetailsModal'
import IndicatorModal from './IndicatorModal'
import MitreAttackModal from './MitreAttackModal'
import VulnerabilityModal from './VulnerabilityModal'
import EmailDigestNotificationModal from './EmailDigestNotificationModal'

export const modals = {
  ActorModal,
  CampaignModal,
  MalwareModal,
  ServiceDetailsModal,
  IndicatorModal,
  MitreAttackModal,
  VulnerabilityModal,
  EmailDigestNotificationModal
}
